export default "__VITE_ASSET__DjNZ2FVs__"